// PendingMessageApprovalEmailListPageUI
import React from 'react';
import { Link } from 'react-router-dom';
import PendingMessageApprovalEmailListUI from '../../../components/superUser/util/PendingMessageApprovalEmailListUI';
import EmptyListUI from '../../../widgets/output/EmptyListUI';
import SuperUserAccountPageUI from '../../../templates/SuperUserAccountPageUI';
import MessageCreateModalSF from '../../../components/superUser/util/MessageCreateModalSF';
import MessageUpdateModalSF from '../../../components/superUser/util/MessageUpdateModalSF';
import SuperUserHomePageUI from '../../../templates/SuperUserHomePageUI';
import SpinnerComponentUI from '../../../components/common/SpinnerComponentUI';
import LRTableActionsUI from '../../../widgets/layout/LRTableActionsUI';
import IconButtonUI from '../../../widgets/action/IconButtonUI';
import AddEmailModalSF from '../../../components/superUser/util/AddEmailModalSF';
import UpdateEmailModalSF from '../../../components/superUser/util/UpdateEmailModalSF';
import PendingMessageApprovalListNavUI from './PendingMessageApprovallListNavUI';

const PendingMessageApprovalEmailListPageUI = ({ context, errorList, selectedMessage, selectedMessageId,
  messageCreateMode, onCreateMessageClick, onCreateMessageCancel,
  sendSubmitted, sendSuccessMsg, sendErrorList, onSendClick, selectedEmail,
  deleteSubmitted, deleteSuccessMsg, deleteErrorList, onDeleteClick,
  onUpdateMessageClick, onUpdateMessageCancel, messageUpdateMode,
  internalSendSubmitted, internalSendSuccessMsg, internalSendErrorList, onSendNoticeToInternalClick,
  uploadSubmitted, uploadSuccessMsg, uploadErrorList, onDocsUploadClick, docsUploadMode, onDocsUploadCancel, onDocsUpload,
  pendingMessageList, onRefreshClick, yearMonth, onPreviousClick, onNextClick, deleteFileMode, selectedFile, onFileDeleteClick,
  onDocDownloadClick, createMode, onAddEmailCancel, onAddEmailClick, onUpdateEmailClick, onUpdateEmailCancel, updateEmailMode,
  onDeleteEmailClick
}) =>
  <SuperUserHomePageUI context={context} className='pg_su_acc' headerText='Pending Email Approvals'
    dimension='w768' centered={!pendingMessageList} page='messageApprovals'>
    {
      (!errorList) && <SpinnerComponentUI />
    }
    {
      pendingMessageList &&
      <LRTableActionsUI location='top'
        left={
          <span className='g_flex_left g_flex_h'>
            <IconButtonUI icon='icon-refresh' onClick={onRefreshClick} />
            <span className='g_m_left_100 g_large'><b>Pending Email Approvals, {yearMonth.monthName} {yearMonth.year}</b></span>
          </span>
        }
        right={
          <span className='g_text_right'>
            <div className='g_flex_h g_flex_right'>
              <span className='g_m_left_100' />
              <Link to='#' onClick={onPreviousClick}>Previous</Link>
              <span className='g_m_left_100' />
              <Link to='#' onClick={onNextClick}>Next</Link>
            </div>
          </span>
        }
      />
    }
    <PendingMessageApprovalListNavUI
      context={context} page='messageApprovals_email'
    />
    {
      pendingMessageList && pendingMessageList.length > 0 &&
      <PendingMessageApprovalEmailListUI messages={pendingMessageList} selectedMessageId={selectedMessageId}
        onCreateMessageClick={onCreateMessageClick} onUpdateMessageClick={onUpdateMessageClick}
        sendSubmitted={sendSubmitted} sendSuccessMsg={sendSuccessMsg} sendErrorList={sendErrorList} onSendClick={onSendClick}
        deleteSubmitted={deleteSubmitted} deleteSuccessMsg={deleteSuccessMsg} deleteErrorList={deleteErrorList} onDeleteClick={onDeleteClick}
        context={context}
        onSendNoticeToInternalClick={onSendNoticeToInternalClick}
        internalSendSubmitted={internalSendSubmitted}
        internalSendSuccessMsg={internalSendSuccessMsg}
        internalSendErrorList={internalSendErrorList}
        onDocsUploadClick={onDocsUploadClick}
        docsUploadMode={docsUploadMode}
        onDocsUpload={onDocsUpload}
        onDocsUploadCancel={onDocsUploadCancel}
        uploadSubmitted={uploadSubmitted}
        uploadSuccessMsg={uploadSuccessMsg}
        uploadErrorList={uploadErrorList}
        deleteFileMode={deleteFileMode}
        selectedFile={selectedFile}
        onFileDeleteClick={onFileDeleteClick}
        onDocDownloadClick={onDocDownloadClick}
        onAddEmailClick={onAddEmailClick}
        onUpdateEmailClick={onUpdateEmailClick}
        onDeleteEmailClick={onDeleteEmailClick}
      />
    }
    {
      pendingMessageList && pendingMessageList.length === 0 &&
      <EmptyListUI context={context} createDisabledMessageLabel='No Pending Email Approvals' />
    }

    <MessageUpdateModalSF context={context}
      message={selectedMessage} messageUpdateMode={messageUpdateMode}
      onUpdateMessageCancel={onUpdateMessageCancel} onRefreshClick={onRefreshClick}
    />

    <AddEmailModalSF
      context={context}
      createMode={createMode}
      message={selectedMessage}
      onAddEmailCancel={onAddEmailCancel}
      onRefreshClick={onRefreshClick}
    />
    <UpdateEmailModalSF
      context={context}
      updateEmailMode={updateEmailMode}
      message={selectedMessage}
      selectedEmail={selectedEmail}
      onUpdateEmailCancel={onUpdateEmailCancel}
      onRefreshClick={onRefreshClick}
    />


  </SuperUserHomePageUI>

export default PendingMessageApprovalEmailListPageUI;
